//jqueryFree
import Nette from 'nette-forms';

/**
 * prevents a valid Nette form from being resubmitted
 */

export const initializeButtons = function () {
	const submitSelector = '[type=submit]';
	document.querySelectorAll('form[data-multiple-submit-prevent="1"]').forEach(function (form) {
		let formSubmitted = false;
		form.querySelectorAll(submitSelector).forEach(function (element) {
			element.addEventListener('click', function (evt) {
				if (Nette.validateForm(evt.target, true)) {
					//form is valid, should be submitted =>
					if (formSubmitted) {
						//form already submitted
						evt.preventDefault();
						console.info('prevent the form from being resubmitted');
						return false;
					}

					//first valid submit
					let form = evt.target.closest('form');
					form.querySelectorAll(submitSelector).forEach(function (submitElement) {
						formSubmitted = true;
						submitElement.style.cursor = 'wait';
						setTimeout(() => submitElement.setAttribute('disabled', true), 100);

						setTimeout(() => {
							formSubmitted = false;
							submitElement.style.cursor = 'auto';
							submitElement.removeAttribute('disabled');
						}, 5000); // po 5 vteřinách povolíme znovuodeslání formuláře
					});
				}
			});
		});
	});
};

export default function () {
	window.addEventListener('load', initializeButtons);
}
